import { MP_LEVELS } from '../../../../../consts/index.js';
import ActivityActionBar from './ActivityActionBar.jsx';
import FlightActionBar from './FlightActionBar.jsx';
import MediaPlanActionBar from './MediaPlanActionBar.jsx';

const mapLevelToActionBar = {
  [MP_LEVELS.MEDIA_PLAN]: MediaPlanActionBar,
  [MP_LEVELS.ACTIVITY]: ActivityActionBar,
  [MP_LEVELS.FLIGHT]: FlightActionBar,
};

const ActionsBarFactory = ({
  level,
}: {
  level: keyof typeof mapLevelToActionBar;
}) => {
  const ActionBarComponent = mapLevelToActionBar[level];

  return <ActionBarComponent />;
};

export default ActionsBarFactory;
